import { render, staticRenderFns } from "./LogbookView.vue?vue&type=template&id=5275bca4&scoped=true"
import script from "./LogbookView.vue?vue&type=script&lang=js"
export * from "./LogbookView.vue?vue&type=script&lang=js"
import style0 from "./LogbookView.vue?vue&type=style&index=0&id=5275bca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5275bca4",
  null
  
)

export default component.exports